export const siteSettings = {
  name: "Alpha Blocks",
  link: "https://alphablocks.net",
  email: "support@alphablocks.net",
  appLink: "https://app.alphablocks.net",
};
